<template>
  <v-window-item :value="3" class="pa-3 fill-height">
    <div v-if="!loaded" class="fill-height">
      <div v-if="!loading" class="fill-height">
        <v-tabs v-model="activeTab" color="primary">
          <v-tab> Upload </v-tab>
          <v-tab> Generate </v-tab>
        </v-tabs>
        <v-window v-model="activeTab" class="pt-3">
          <v-window-item class="py-3">
            <ShapeFileUpload
              @fetchGeometryFieldNames="fetchGeometryFieldNames('reference_points')"
              @updateFieldName="fieldName = $event"
              @updateFileName="fileName = $event"
              :field-name="fieldName"
              :field-names="fieldNames"
              :file-name="fileName"
              :loading-field="loadingField"
            />
          </v-window-item>
          <v-window-item>
            <div class="mt-10 mb-6">
              <v-row>
                <v-col cols="8">
                  <v-slider
                    color="primary"
                    v-model="distance"
                    thumb-label
                    label="Range"
                    step="5"
                    min="1"
                    max="500"
                  ></v-slider>
                </v-col>
                <v-col cols="3" class="pr-0 pl-0 pt-2">
                  <v-text-field
                    density="compact"
                    suffix="m"
                    variant="outlined"
                    type="number"
                    hide-details
                    v-model="distance"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-window-item>
        </v-window>
      </div>
      <div style="height: 10%" class="py-3">
        <v-btn
          class="float-right"
          :disabled="!fieldName && activeTab === 0"
          color="primary"
          :loading="uploading"
          @click="activeTab === 0 ? uploadFile() : generateFromDistance()"
        >
          Upload & Continue
        </v-btn>
        <v-btn variant="plain" @click="$emit('back')"> Back </v-btn>
      </div>
    </div>
    <div v-else class="fill-height">
      <div class="fill-height">
        <v-data-table
          class="overflow-y-auto fill-height"
          fixed-header
          hide-default-footer
          density="compact"
          :items-per-page="-1"
          :items="referencePoints.features"
          :headers="headers"
        >
          <template #bottom> </template>

          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:[`item.properties.color`]="{ item }">
            <v-icon :color="item.properties.color"> mdi-circle-medium </v-icon>
          </template>
        </v-data-table>
      </div>

      <div class="py-3">
        <v-btn color="primary" @click="$emit('continue')" variant="flat" class="float-right">
          Continue
        </v-btn>
        <v-btn variant="text" @click="$emit('back')"> Back </v-btn>
        <v-btn :loading="deleteLoading" @click="deleteAllResetState()" variant="flat" color="error">
          Delete all
        </v-btn>
      </div>
    </div>
  </v-window-item>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ShapeFileUpload from '@/components/dike/ShapeFileUpload.vue'
import DikeTrajectoryUploadFileMixin from '@/mixins/DikeTrajectoryUploadFileMixin.vue'
import DikeTrajectoryGenerateMixin from '@/mixins/DikeTrajectoryGenerateMixin.vue'

export default {
  name: 'DikeReferencePointsUploadShapeFileStep',
  components: { ShapeFileUpload },
  mixins: [DikeTrajectoryUploadFileMixin, DikeTrajectoryGenerateMixin],
  props: {
    step: {}
  },
  data: () => ({
    uploading: false,

    activeTab: 0,
    headers: [
      { title: '', value: 'properties.color' },
      { title: 'Index', value: 'index', width: '10%' },
      { title: 'Reference point', value: 'properties.name' }
    ]
  }),
  computed: {
    ...mapState('referencePoint', {
      loaded: (state) => state.loaded,
      loading: (state) => state.loading,
      deleteLoading: (state) => state.deleteLoading,
      referencePoints: (state) => state.items
    })
  },
  methods: {
    ...mapActions('referencePoint', {
      upload: 'upload',
      deleteAll: 'deleteAll',
      generate: 'generate',
      resetState: 'resetState'
    }),
    async deleteAllResetState() {
      await this.deleteAll()
      await this.resetState()
    }
  }
}
</script>
